<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Dados do Boleto</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-xs-12">
							<router-link :to="`/boleto/${$props.solicitacao.id}`" class="btn btn-default btn-sm pull-right" target="_blank" ><span class="fa fa-print"></span></router-link>
						</div>
					</div>
					<solicitacao-boleto v-if="$props.solicitacao != null" :solicitacao="$props.solicitacao"></solicitacao-boleto>
				</div>
				<div class="modal-footer">
					<div class="text-right" style="float:right">
						<button class="btn btn-default" @click="$emit('close')">
							<i class="fa fa-close"></i> Fechar
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import SolicitacaoBoleto from "../comuns/solicitacaoBoleto";
	export default {
		props: ["solicitacao"],

		data: () => ({

		}),
		mounted() {

		},
		methods: {

		},
		watch: {},
		components: {
			SolicitacaoBoleto
		}
	};
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s ease;
	}

	.modal-container {
		width: 50%;
		margin: 40px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		margin: 10px 0;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal {
		display: block !important;
		/* I added this to see the modal, you don't need this */
	}


	/* Important part */

	.modal-dialog {
		overflow-y: initial !important;
	}

	.modal-body {
		height: 400px;
		overflow-y: auto;
	}
	section {
		font-size: 14px !important;
	}
</style>



// WEBPACK FOOTER //
// modalBoleto.vue?7f97eb74